import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
// import nativeJSBridge from '@/utils/nativeJSBridge'
import store from './store'
import "amfe-flexible" // 引入flexible
import Vant from 'vant-ui';  // 引入vant-ui。
import 'vant/lib/index.css';

import './assets/iconfont/iconfont.css'

// // 引入vue-UUID组件
// import UUID from 'vue-uuid'
// Vue.use(UUID)

Vue.use(Vant);

import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

import './permission' // permission control
// console.log(`run in ${process.env.NODE_ENV}`)

// import signature from './packages/index'
// Vue.use(signature)

//设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false
new Vue({
    router,
    // nativeJSBridge,
    store,
    render: h => h(App),
}).$mount('#app')
